(() => {
  function setupHeader() {
    const header = document.querySelector('.bep-header-final');
    if (!header || header.dataset.accessibleDrawer === 'ready') return;
    const toggle = header.querySelector('.bep-header-final__drawer-toggle');
    const opener = header.querySelector('.bep-header-final__menu-btn');
    const drawer = header.querySelector('.bep-header-final__drawer');
    const closer = header.querySelector('.bep-header-final__drawer-close');
    const overlay = header.querySelector('.bep-header-final__overlay');
    if (!toggle || !opener || !drawer || !closer || !overlay) return;
    header.dataset.accessibleDrawer = 'ready';
    const setOpen = (open) => {
      toggle.checked = open;
      opener.setAttribute('aria-expanded', String(open));
      drawer.inert = !open;
      document.body.classList.toggle('bep-menu-open', open);
      if (open) closer.focus();
      else opener.focus();
    };
    opener.addEventListener('click', () => setOpen(!toggle.checked));
    closer.addEventListener('click', () => setOpen(false));
    overlay.addEventListener('click', () => setOpen(false));
    header.addEventListener('keydown', (event) => {
      if (!toggle.checked) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
      } else if (event.key === 'Tab') {
        const focusable = Array.from(drawer.querySelectorAll('a[href], button, summary, [tabindex="0"]'))
          .filter((element) => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }
  setupHeader();
  document.addEventListener('shopify:section:load', setupHeader);
})();
